<template>
  <div
    class="fixed bottom-0 z-10 max-w-screen ml-12 mb-60"
    v-if="!$pwa?.isPWAInstalled && installPWA"
  >
    <button
      class="bg-orange text-gray-900 px-8 py-4 uppercase text-sm font-bold rounded-sm shadow mb-4 w-full flex items-center justify-center gap-2"
      aria-label="Agregar mibiotren.cl al inicio"
      v-umami="{ name: 'pwa-install' }"
      @click="onClickInstallPWA"
    >
      <LucideSmartphone :size="16" />
      <span> Agregar <strong>MiBiotren</strong> al inicio </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import type { BeforeInstallPromptEvent } from '~~/interfaces';

const { $pwa } = useNuxtApp();
const installPWA = ref<BeforeInstallPromptEvent | null>(null);

const onClickInstallPWA = async () => {
  try {
    if (installPWA.value) {
      installPWA.value.prompt();
      const { outcome } = await installPWA.value.userChoice;
      if (outcome === 'accepted') {
        await $pwa?.install();
        console.log('User accepted the A2HS prompt');
      } else {
        console.log('User dismissed the A2HS prompt');
      }
    }
  } catch (error) {
    console.error(error);
  } finally {
    installPWA.value = null;
  }
};

onMounted(() => {
  window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    installPWA.value = e as BeforeInstallPromptEvent;
  });
});
</script>
